import React, { useState, useRef, useEffect } from "react";

import GradPic2 from "../../image/grad-pic.jpg";
import HymnAudio from "../../image/hymn.mp3";
export default function Hymn() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const toggleAudio = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="bg-secondary-lightActive flex flex-col md:items-center">
      <div className="responsive-padding py-10 ">
        {" "}
        <h1 className="Uppercase font-montserrat font-bold text-2xl leading-4 align-middle text-text-dark text-center">
          JMIF HYMN{" "}
        </h1>
        <div className="text-grey-normal text-center mt-5 text-base tracking-[0.08em]">
          <p className="italic font-notoSans leading-3">
            Lyrics by:{" "}
            <span className="font-medium">Dr. Lolita D. Rodriguez</span>
          </p>
          <p className="italic font-notoSans">
            Tune:
            <span className="font-medium"> Roses are Red</span>
          </p>
        </div>
        <div className="flex flex-col laptopSm:flex-row-reverse gap-4 py-7 laptopSm:py-12">
          <div className="laptopSm:w-1/2 flex flex-col items-center laptopSm:items-end">
            <div className="relative w-full max-w-[371px] h-[280px] laptopSm:h-[409px] border-[12px] border-grey-normal ">
              <img
                src={GradPic2}
                alt={GradPic2}
                className="w-full h-full object-cover object-center"
              />
              {/* Audio element */}
              <audio
                ref={audioRef}
                src={HymnAudio}
                autoPlay={false}
                onEnded={() => {
                  setIsPlaying(false);
                }}
              ></audio>

              <div
                className="absolute h-[65px] w-full bottom-0 opacity-90"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(253, 229, 239, 0) 2.8%, rgba(253, 229, 239, 0.5) 43.3%, rgba(240, 188, 210, 0.75) 65.8%, #EDB6CD 88.3%)",
                }}
              ></div>
            </div>
            <div className="w-full max-w-[371px] h-[70px] bg-grey-normal flex items-center justify-center relative -top-[10px] ">
              <div
                onClick={toggleAudio}
                className="flex items-center justify-center w-[45px] h-[45px] laptopSm:w-[50px] laptopSm:h-[50px]  bg-white rounded-full cursor-pointer"
              >
                {isPlaying ? (
                  <svg
                    className="w-[15px] h-[17px] laptopSm:w-[24px] laptopSm:h-[24px] fill-none"
                    viewBox="0 0 15 17"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    {/* Pause Icon */}
                    <path d="M2 0h3v14H2V0zm8 0h3v14h-3V0z" fill="#D9D9D9" />
                  </svg>
                ) : (
                  <svg
                    className="w-[15px] h-[17px] laptopSm:w-[24px] laptopSm:h-[24px] fill-none"
                    viewBox="0 0 15 17"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    {/* Play Icon */}
                    <path
                      d="M13.7871 6.4629C15.1204 7.2327 15.1204 9.15721 13.7871 9.92701L3.5337 15.8468C2.20036 16.6166 0.533693 15.6543 0.533693 14.1147V2.27517C0.533693 0.735571 2.20036 -0.226682 3.53369 0.543118L13.7871 6.4629Z"
                      fill="#D9D9D9"
                    />
                  </svg>
                )}
              </div>
            </div>
          </div>
          <div className="laptopSm:w-1/2  font-montserrat text-base tracking-[0.08em] leading-[30px] text-center text-grey-normal  flex flex-col gap-y-5 ">
            <p>
              Amidst the Muslim Land <br />
              Now stand JMIF headed by <br />
              Sultan Rashid youth hopes there now lie
            </p>

            <div>
              <strong>[Chorus]</strong>

              <p>Among the old tall trees Where green ferns grow so high </p>
              <p>You shine your lovely rays Jamiatu Marawi</p>
              <p>
                The cradle of its grace from IQRAA-IDB people there Should be
                praised Ali and Yamani
              </p>
            </div>
            <strong>[Repeat Chorus]</strong>

            <p>
              Sail on JMIF Go now to destiny find guide in Sampaco inspired by
              Ulamas
            </p>
            <p>
              Here in JMIF student are God-Fearing conscious of Their duties to
              serve Him their best
            </p>
            <strong>[Repeat Chorus]</strong>
          </div>
        </div>
      </div>
    </div>
  );
}
